<template>
    <FormSearchSelect
        v-bind="$attrs"
        class="FormSelectSite"
        :value="value"
        :label="label"
        :options="sites"
        :reduce="site => site.id"
        :getOptionLabel="site => site.name"
        @input="handleInput"
    >
        <template v-if="showCreateOption" #list-header>
            <ButtonIcon icon="plus" class="block" @click="handleCreate">
                Add new
            </ButtonIcon>
        </template>
    </FormSearchSelect>
</template>

<script>
import { mapState } from 'vuex';
import SiteCreateModal from '@/components/modals/SiteCreateModal';

export default {
    name: 'FormSelectSite',
    inheritAttrs: false,

    props: {
        value: { type: Number },
        label: { type: String, default: 'Site' },
        showCreateOption: { type: Boolean, default: false },
    },

    data: () => ({
        initialValue: null,
    }),

    computed: {
        ...mapState('company', ['sites']),
    },

    beforeMount() {
        this.initialValue = this.value;
    },

    methods: {
        handleInput(siteId) {
            this.$emit('input', siteId);
        },

        handleCreate() {
            this.$analytics.trackButtonClick(this.$options.name, 'prompt_create_site', {
                model_type: 'site',
                model_action: 'create_intent',
            });

            this.$modal.show(SiteCreateModal, {
                onSiteCreated: this.handleSiteCreated,
            });
        },

        handleSiteCreated(newSite) {
            this.$emit('input', newSite.id);
        },
    },
};
</script>

<style lang="scss" scoped>
.FormSelectSite {
    .ButtonIcon {
        justify-content: flex-start;
    }
}
</style>